import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../Components/PreOrderTicketCard/TicketCard.css";
import { FiArrowRight } from "react-icons/fi";
import pingleLogo from "../../Assets/Images/pingle.png";

export default function TicketCard({ Data, fromPage }) {



  const DEFAULT_Ticket_IMAGE_URL =
    "https://theme-assets.getbento.com/sensei/6941e9b.sensei/assets/images/catering-item-placeholder-704x520.png";
  const DEFAULT_IMAGE_URL =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScO99JkPvdfSyT3CbMrYsKBpRuXOACVR2cP9F6DBcP9B6nQ9oszX_18T-2oNv6Gyxwyhk&usqp=CAU";

  const { vendor_id } = useParams();

  const textRef = useRef(null);
  console.log(Data, '----------------------',);
  const [lineWidth, setLineWidth] = useState(0);
  const [data, setData] = useState(Data);
  const navigate = useNavigate();
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [ticketId, setTicketId] = useState(data?.ticket_id);
  const location = useLocation()
  const { select_date } = location.state || {};
  const [showContainer, setShowContainer] = useState(true);


  useEffect(() => {
    setData((prevData) => (prevData != Data ? Data : prevData));
  }, [vendor_id, Data]);


  useEffect(() => {
    if (textRef.current) {
      setLineWidth(textRef.current.offsetWidth);
    }
  }, [data?.ticket_name]);


  console.log('data------', data);

  return (
    <div className={`card-main-box-container p-2 mt-2 mb-2 `}>
      {showContainer ?

        <div className={`preorder-card-main-box  ${data?.card_colour && data?.card_colour !== "transparent" && "ImageDesign"}`}
          style={{ background: data.card_colour && data.card_colour !== "transparent" ? data.card_colour : data.card_pattern ? `url(${data.card_pattern})` : 'rgb(231, 52, 96)', backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat", }} >

          <div className="conatiner-left">
            <img src={`${data.images || DEFAULT_Ticket_IMAGE_URL}`} alt="Preview" className="image" width={"100px"} height={"175px"}
              onError={(e) => e.target.src = DEFAULT_Ticket_IMAGE_URL} />
          </div>

          <div className="conatiner-right-Card"      >

            <div className="content-top p-0 d-flex justify-content-between align-items-center">
              <span className="store-name p-0 fs-14 ff-poppins-semiBold text-white">
                {data.vendor_company_name}
              </span>
              <button className="flip_btn ff-poppins-medium col-4 rounded-3 p-1" onClick={() => setShowContainer(false)}>Flip</button>
            </div>
            <div className="content-bottom mt-1">

              <div>
                <div ref={textRef} className="fs-11 ff-poppins-semiBold text-uppercase text-white"   >
                  {data.ticket_name || "TICKET NAME"}
                </div>
                <div className="gradient-line"  ></div>
              </div>
              <p className="content ff-poppins-medium fs-10 text-white">
                {(
                  data?.about ||
                  "This ticket is for food, making preordering easy, convenient, budget..."
                ).slice(0, 70) + (data?.about?.length > 70 ? "..." : "")}
              </p>
              <div className="d-flex justify-content-between">
                <div className="price fs-12 ff-poppins-semiBold text-white">
                  <span className="rupeeIcon "> ₹ </span>{data.ticket_price || "00.0"}
                </div>
                {data?.quantity == 1 &&
                  <span className="price fs-12 ff-poppins-medium text-white">
                    Available :  {data.quantity_count}
                  </span>}
              </div>
            </div>

            <div className="footer">
              <span className="bottom-left fs-12 ff-poppins-regular text-white"></span>
              <button className={`buyNow fs-11 ff-poppins-regular ${fromPage == 'single' || fromPage == 'reviewpay' ? 'px-3 py-1' : "px-2 py-1"}`} onClick={() => fromPage == 'single' ? "" : navigate(`/single_tickt_detail/${data.vendor_id}/${data.ticket_id}`, { state: { select_date: data.selected_date } })}>
                {fromPage == 'single' || fromPage == 'reviewpay' ?
                  <span>Ticket</span> :
                  <span>  Buy Now <FiArrowRight className="ms-1 fs-14" /></span>
                }
              </button>
            </div>

            {/* <div className="footer">
              <button className={`flip_btn fs-10  ff-poppins-medium rounded-2 ${fromPage == 'single' || fromPage == 'reviewpay' ? 'px-3' : "p-1"} `}
                onClick={() => fromPage == 'single' ? "" :navigate(`/single_tickt_detail/${data.vendor_id}/${data.ticket_id}`, { state: { select_date: data.selected_date } })}>

                {fromPage == 'single' || fromPage == 'reviewpay' ?
                  <span>Ticket</span> :
                  <span>  Buy Now <FiArrowRight className="ms-1 fs-14" /></span>
                }
              </button>
            </div> */}

          </div>

        </div>
        :
        <div>

          <div className={`preorder-card-main-box  ${data?.card_colour && data?.card_colour !== "transparent" && "ImageDesign"}`}
            style={{
              background: data.card_colour && data.card_colour !== "transparent" ? data.card_colour : data.card_pattern ? `url(${data.card_pattern})` : 'rgb(231, 52, 96)',
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }} >
            <div className="conatiner-center">
              <div className="content-top-center">
                <div className="bLL"></div>
                <div className="bL">
                  <span className="store-name fs-14 ms-5 ff-poppins-semiBold text-white">
                    {data.vendor_company_name}
                  </span>
                </div>
                <button className="flip_btn mt-1 ff-poppins-medium col-3 rounded-3 p-1" onClick={() => setShowContainer(true)}>Flip</button>

              </div>
              <div className="left">
                <span className="px-4 fs-14 ff-poppins-semiBold text-uppercase text-white text-left">
                  {data.ticket_name}
                </span>
              </div>
              <div className="text-center">
                <div>
                  <span className="content-right ff-poppins-bold fs-19 text-white">
                    {data.ticket_id}
                  </span> <br></br>
                  <span className="ms-5 ps-5 fs-12 p-0 m-0 ff-poppins-regular text-white">
                    Ticket Id
                  </span>
                </div>
              </div>
              <div className="preOrder-bottom-container">

                <div className="logo d-flex">
                  <img
                    className="bottom-right"
                    src={pingleLogo}
                    width={"100%"}
                    height={"100%"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }

    </div>
  );
}
